<template>
    <div>
	    <textarea class="form-control" v-model="handler" @input="change" rows="6"></textarea>
	    <div class="helper-text">
	    	um link por linha
	    </div>
    </div>
</template>

<style scoped>
	.helper-text { font-size:.9em}

</style>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){

		var dom = htmlToDom(blockObj.template);

		this.handler = Array.from(dom.querySelectorAll('.list a')).reduce((carry,item)=>{
			carry.push(item.getAttribute('href'));
			return carry;
		},[]).join("\n");


  },
  methods:{
    change(){

    	var links = this.handler.split("\n").filter(line=>!!line.trim());

    	var listItem = links.map(link=>{
    		var match = link.match(/(youtu.be\/|youtube.com\/watch\?v=|youtube.com\/embed\/)([a-zA-Z0-9_-]+)/);
    		if(!match) return'';
    		var videoId = match.pop();
    		var image = `https://i3.ytimg.com/vi/${videoId}/mqdefault.jpg`;
    		var href = `https://www.youtube.com/watch?v=${videoId}`;
    		return `<li><a href="${link}"><img src="${image}"></a></li>`;
    	});

			var dom = htmlToDom(blockObj.template);

			dom.querySelector('.list ul').innerHTML = listItem.join("\n");

			blockObj.template = dom.outerHTML;

			updateIframe();

			this.$emit('change','');

    },
  }

}
</script>
